enum GameDimensionTypeValues {
  INDIVIDUAL = 'Individual',
  TEAM = 'Team',
}

export default GameDimensionTypeValues;
